import { createSlice } from '@reduxjs/toolkit';
import { phoenixToday } from '../../utils/phoenixTime';

const initialState = {
  selectedDate: phoenixToday(),
  filters: {
    waiting_review: false,
    transaction_complete: false,
    processing: false,
    partial_orders: false,
  },
  viewMode: 'table',
  searchFilter: '',
  roomFilter: '',
  assigneeFilter: '',
  selectedStatus: '',
  orderTableSearchFilter: '',
  isByRoomEnabled: true,
  selectedRoom: undefined,
};

const frontdeskSlice = createSlice({
  name: 'frontdesk',
  initialState,
  reducers: {
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setViewMode: (state, action) => {
      state.viewMode = action.payload;
    },
    setSearchFilter: (state, action) => {
      state.searchFilter = action.payload;
    },
    setRoomFilter: (state, action) => {
      state.roomFilter = action.payload;
    },
    setAssigneeFilter: (state, action) => {
      state.assigneeFilter = action.payload;
    },
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload;
    },
    setOrderTableSearchFilter: (state, action) => {
      state.orderTableSearchFilter = action.payload;
    },
    setIsByRoomEnabled: (state, action) => {
      state.isByRoomEnabled = action.payload;
    },
    setSelectedRoom: (state, action) => {
      state.selectedRoom = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.searchFilter = '';
      state.roomFilter = '';
      state.assigneeFilter = '';
      state.selectedStatus = '';
    },
  },
});

export const {
  setSelectedDate,
  setFilters,
  setViewMode,
  setSearchFilter,
  setRoomFilter,
  setAssigneeFilter,
  setSelectedStatus,
  setOrderTableSearchFilter,
  setIsByRoomEnabled,
  setSelectedRoom,
  resetFilters,
} = frontdeskSlice.actions;

export default frontdeskSlice.reducer;

